import personImageSrc from 'components/OnePageTemplates/mockData/personPhoto.jpg';

import { ReactComponent as MockLogoWhite } from '../mockData/mockLogoWhite.svg';

export const EXAMPLE_DOC_DE = {
  companyLogo: <MockLogoWhite />,
  companyName: 'Agrotech',
  projectBriefDescription:
    'Entwicklung kälteresistenter Weizensorten, einschließlich Forschung, Feldversuchen und Produktionsausweitung. Zielmarkt: Agrarsektor, Weizenanbau. Akquisitionsgrund: Bewältigung der Herausforderungen des Klimawandels, Sicherstellung der Ernährungssicherheit.',
  lifeCycleStage: 'R&D',
  annualIncome: '$65,000,000',
  projectPaybackPeriod: '3 months',
  forecastedProfitability: '15%',
  fundingAmount: '$65,000,000',
  totalCost: '$65,000,000',
  percentageOfFunding: '30%',
  companyBriefDescription:
    'Führendes Agrarbiotechnologieunternehmen mit Sitz in den USA, spezialisiert auf die Forschung, Entwicklung und Vermarktung innovativer Getreidesorten. Das Unternehmen konzentriert sich darauf, zukunftsweisende Lösungen für die sich wandelnden Bedürfnisse von Landwirten und der gesamten Lebensmittelindustrie bereitzustellen. Mithilfe molekularbiologischer Verfahren und genetischer Modifikation entwickelt das Unternehmen Hochleistungssorten mit verbessertem Ertrag, erhöhter Krankheitsresistenz und Anpassungsfähigkeit an unterschiedliche Umweltbedingungen.',
  operatingIndustry: 'Forschung, Entwicklung und Vermarktung innovativer Getreidesorten',
  registrationDate: '11.11.2002',
  numberOfEmployees: '150',
  mainGoals:
    'Entwicklung kälteresistenter Weizensorten, Investitionen in Forschung, Produktionsausweitung, Sicherstellung der Nachhaltigkeit. Schlüsselstrategien: Investitionen in Forschung und Entwicklung, Kooperationen, Marktexpansion, Erfolgskontrolle.',
  strategyForAchievingGoals:
    'Die Entwicklung kälteresistenterer Getreidesorten kann Landwirten eine widerstandsfähigere und anpassungsfähigere Kulturpflanze bieten. Diese kälteresistenten Getreidesorten werden speziell so entwickelt, dass sie extremen Kältetemperaturen standhalten und so höhere Überlebensraten und nachhaltiges Wachstum auch unter widrigen Winterbedingungen gewährleisten. Dieser technologische Fortschritt zielt darauf ab, die Auswirkungen von Kälte auf Getreidekulturen zu mindern und so letztendlich zu höheren Erträgen, wirtschaftlicher Stabilität für die Landwirte und Ernährungssicherheit für das Land beizutragen.',
  mainProductsOrServices:
    'Das Unternehmen ist auf kälteresistente Weizensorten spezialisiert und ermöglicht Landwirten den Zugang zu widerstandsfähigen Nutzpflanzen, die auch unter schwierigen Klimabedingungen gedeihen. Es bietet die Weizensorte 1 an, die speziell für Felder in kalten Klimazonen entwickelt wurde, und plant die Einführung der Weizensorte 2 mit höherer Kältetoleranz.',
  competitionAdvantage:
    'Die Entwicklung kälteresistenter Weizensorten umfasst Forschung, Feldversuche und Produktionsausweitung. Zielmarkt: Agrarsektor, Weizenanbau. Ziel der Akquisition: Bewältigung der Herausforderungen des Klimawandels, Sicherstellung der Ernährungssicherheit.',
  targetMarket:
    'Der Zielmarkt umfasst Weizenfarmen in South Dakota und North Dakota. 2022 wurden in South Dakota 4 Millionen Tonnen und in North Dakota 4,2 Millionen Tonnen Weizen angebaut. Der Gesamtmarktwert wird auf 103 Milliarden US-Dollar geschätzt. In South Dakota gab es 2022 20.501 Weizenfarmen, in North Dakota 21.003.',
  mainCompetitors:
    '120 Lieferantenunternehmen konkurrieren auf dem Weizenmarkt. American AGRO ist mit einem Marktanteil von 15 % Marktführer. Weitere Wettbewerber sind EcoWheat und Grain Processing Corporation.',
  targetChannels:
    'Zu den Kunden zählen 41.505 mittlere und kleine Weizenbauern in South Dakota und North Dakota. Merkmale der Landwirte in North Dakota: Sie sind zwischen 20 und 50 Jahre alt, bewirtschaften kleine bis mittlere Betriebe und suchen nach dürreresistenten Weizensorten und nachhaltigen Anbaumethoden.',
  revenueStreams:
    'Die Haupteinnahmequellen umfassen den Verkauf von gentechnisch verändertem Saatgut, Lizenzverträge für geistige Eigentumsrechte und Beratungsleistungen zur Pflanzenentwicklung. Zu den zentralen finanziellen Annahmen zählen die Marktnachfrage nach Hochleistungssorten, erfolgreiche Forschungs- und Entwicklungsergebnisse, die Akzeptanz bei den Landwirten, behördliche Genehmigungen und die betriebliche Effizienz. Wichtige Partner sind Forschungseinrichtungen, landwirtschaftliche Verbände, Saatguthändler und Aufsichtsbehörden, die Innovationen, Markterschließung und die Einhaltung branchenüblicher Vorschriften unterstützen.',
  marketingStrategy:
    'Landwirtschaftliche Einzelhändler und Genossenschaften, Online-Plattformen und E-Commerce-Anbieter, Saatguthändler und -großhändler',
  projectStatus: ['Research and Development'],
  team: 'Zum Kernteam des Projekts gehören: Edward Lando – CEO (Chief Executive Officer), Naval Ravikant – CFO (Chief Financial Officer), Fabrice Grinda – Leitender Wissenschaftler',
  dynamics:
    'Die landwirtschaftliche Nutzfläche wächst in South Dakota und North Dakota jährlich um 2.000 Hektar. Aufgrund technologischer Fortschritte und der regulatorischen Unterstützung für gentechnisch veränderte Organismen (GVO) wird ein Marktwachstum von 4 % CAGR zwischen 2022 und 2030 erwartet.',
  problemOfMarket:
    'Landwirte auf dem US-amerikanischen Getreidemarkt stehen aufgrund der zunehmend unberechenbaren und harten Winterwetterbedingungen vor großen Herausforderungen. Die Anfälligkeit traditioneller Getreidearten gegenüber extremen Kältetemperaturen führt häufig zu Ertragsminderungen, Ernteausfällen und finanziellen Verlusten für die Landwirte. Diese Kälteempfindlichkeit gefährdet die Stabilität und Produktivität des US-amerikanischen Getreidemarktes.',
  projectedAnnualIncome: '65000000',
  projectedAnnualProfit: '65000000',
  returnOnInvestment: '20',
  internalRateOfReturn: '25',
  teamMembers: [
    {
      fullName: 'Edward Lando',
      position: 'CEO (Chief Executive Officer)',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Oklahoma State University, Finanzen',
      workExperience:
        'April 2017 – Mai 2020, ARP Dend, Finanzmanager\nEntwicklung und Pflege von Finanzmodellen zur Prognose der Unternehmensleistung. Analyse von Finanzdaten zur Gewinnung von Erkenntnissen über Umsatztrends, Kostenstrukturen und Rentabilität. Bewertung der finanziellen Risiken des Unternehmens und Entwicklung von Strategien zu deren Minderung.',
      keySkills: 'Problemlösung',
      achievements:
        'Leitete die Expansion des Unternehmens in 12 neue Märkte, was zu einer Steigerung des weltweiten Umsatzes um 40 % führte.',
    },
    {
      fullName: 'Edward Lando',
      position: 'CEO (Chief Executive Officer)',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Oklahoma State University, Finanzen',
      workExperience:
        'April 2017 – Mai 2020, ARP Dend, Finanzmanager\nEntwicklung und Pflege von Finanzmodellen zur Prognose der Unternehmensleistung. Analyse von Finanzdaten zur Gewinnung von Erkenntnissen über Umsatztrends, Kostenstrukturen und Rentabilität. Bewertung der finanziellen Risiken des Unternehmens und Entwicklung von Strategien zu deren Minderung.',
      keySkills: 'Problemlösung',
      achievements:
        'Leitete die Expansion des Unternehmens in 12 neue Märkte, was zu einer Steigerung des weltweiten Umsatzes um 40 % führte.',
    },
    {
      fullName: 'Edward Lando',
      position: 'CEO (Chief Executive Officer)',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Oklahoma State University, Finanzen',
      workExperience:
        'April 2017 – Mai 2020, ARP Dend, Finanzmanager\nEntwicklung und Pflege von Finanzmodellen zur Prognose der Unternehmensleistung. Analyse von Finanzdaten zur Gewinnung von Erkenntnissen über Umsatztrends, Kostenstrukturen und Rentabilität. Bewertung der finanziellen Risiken des Unternehmens und Entwicklung von Strategien zu deren Minderung.',
      keySkills: 'Problemlösung',
      achievements:
        'Leitete die Expansion des Unternehmens in 12 neue Märkte, was zu einer Steigerung des weltweiten Umsatzes um 40 % führte.',
    },
  ],
  contacts: {
    websiteUrl: 'agrotech.com',
    phone: '1(062)7266363',
    email: 'office@agrotech.com',
    fullNameWithPos: 'John Doe, CEO',
    address: '699 Walnut St. Suite 1800, Des Moines, IA 50309, United States.',
  },
  financingNeedsChart: {
    otherCost: { percentage: '8.333333333333332', currencyAmount: '50' },
    researchCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    equipmentCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    marketingCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    constructionCost: { percentage: '25', currencyAmount: '150' },
    workingCapitalCost: { percentage: '16.666666666666664', currencyAmount: '100' },
  },
  implementationPlanStages: [
    {
      stage: 'Forschungs- und Entwicklungsplanung (F&E)',
      from: '2024-01-05T21:00:00.000Z',
      to: '2024-02-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Erste Kälteresistenzanalyse durchführen',
      from: '2024-02-05T21:00:00.000Z',
      to: '2024-03-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Strategien zur genetischen Modifizierung entwickeln (falls zutreffend)',
      from: '2024-03-05T21:00:00.000Z',
      to: '2024-05-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Saatgutauswahl und -beschaffung',
      from: '2024-04-05T21:00:00.000Z',
      to: '2024-08-05T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Versuchsfelder anlegen',
      from: '2024-07-05T21:00:00.000Z',
      to: '2024-07-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Kälteresistente Weizensorten anpflanzen',
      from: '2024-07-05T21:00:00.000Z',
      to: '2024-07-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Ergebnisse analysieren und optimieren',
      from: '2024-08-05T21:00:00.000Z',
      to: '2024-08-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Produktionsausweitung',
      from: '2024-09-05T21:00:00.000Z',
      to: '2024-10-05T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
    {
      stage: 'Marketing- und Vertriebsstrategie entwickeln',
      from: '2024-10-05T21:00:00.000Z',
      to: '2024-12-05T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
    {
      stage: 'Produkteinführung',
      from: '2024-12-05T21:00:00.000Z',
      to: '2024-12-25T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
  ],
};
